export default function TickIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M21.7073 5.2931C22.0977 5.68374 22.0975 6.31691 21.7069 6.70731L9.69984 18.7073C9.51221 18.8948 9.25777 19.0001 8.9925 19C8.72723 18.9999 8.47288 18.8944 8.28542 18.7067L2.29248 12.7067C1.90218 12.3159 1.90256 11.6828 2.29331 11.2925C2.68406 10.9022 3.31723 10.9026 3.70752 11.2933L8.99357 16.5856L20.2931 5.29269C20.6837 4.90228 21.3169 4.90246 21.7073 5.2931Z"
            fill="#33897D"/>
    </svg>
  )
}
